// extracted by mini-css-extract-plugin
export default {"advantagesContainer":"styles_advantagesContainer__QxP0e"};